import { render, staticRenderFns } from "./messageTotal.vue?vue&type=template&id=5c10000e&scoped=true"
import script from "./messageTotal.vue?vue&type=script&lang=js"
export * from "./messageTotal.vue?vue&type=script&lang=js"
import style0 from "./messageTotal.vue?vue&type=style&index=0&id=5c10000e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10000e",
  null
  
)

export default component.exports